import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const PageToggleButtonGroupCopy = ({ alignment, setAlignment, buttonList , adjacentButtonEnabled = true }) => {

    const handleChange = (event, newAlignment) => {
        setAlignment(alignment => alignment = newAlignment);
    };

    const getButtonStyling = (adjacentButtonEnabled) =>{
      if(adjacentButtonEnabled){
          return {
            border:"1px solid #00A6CA",
            fontSize:"14px",
            lineHeight:"24px",
            fontFamily:"Roboto medium, Helvetica, Arial, sans-serif",
            whiteSpace:"nowrap",
            color: "#001317",
            "&.Mui-selected": {
              backgroundColor:"#00A6CA",
              color: "#fff",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "#00A6CA",
              color: "#fff",
            },
            "&:hover": {
              backgroundColor:"#33B8D1",
              color: "#fff",
            },
          }
      }else{
          return {
            margin:'0 5px',
            border:"1px solid #3D3D3D",
            borderRadius:"20px",
            fontSize:"14px",
            lineHeight:"24px",
            fontFamily:"Roboto medium, Helvetica, Arial, sans-serif",
            whiteSpace:"nowrap",
            color: "#3D3D3D",
            "&.Mui-selected": {
              backgroundColor:"#3D3D3D",
              color: "#fff",
            },
            "&.Mui-selected:hover": {
              backgroundColor:"#3D3D3D",
              color: "#fff",
            },
            "&:hover": {
              backgroundColor:"#4d4d4d",
              color: "#fff",
            },
            '&:not(:first-of-type)': {
              borderLeft: '1px solid #3D3D3D', // Ensure left border is present
              borderRadius:"20px"
            },
            '&:first-of-type': {
              borderRadius:"20px", // Rounded corners for the first button
            },
          }
      }
    }

    return (
      <ToggleButtonGroup
        value={alignment}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
      >
        {buttonList.map((el) => {
          if (el["active"]) {
            return (
              <ToggleButton
                disableRipple
                className='p-3 pt-2 pb-2'
                sx={getButtonStyling(adjacentButtonEnabled)}
                value={el["key"]}
              >
                {el["tag"]}
              </ToggleButton>
            );
          }
        })}
      </ToggleButtonGroup>
    );
}

export default PageToggleButtonGroupCopy; 